import { FC } from 'react';
import Button from '../../components/Button/Button';
import Logo from '../../common/Logo/Logo';
import { StyledContainer, LoginCard, LogoSection, LogoWrapper, Title } from './Login.styles';

export const Login: FC = () => {
  const handleLoginClick = () => window.location.replace(`${process.env.REACT_APP_OPSUI_API_URL}/login`);

  return (
    <StyledContainer>
      <LogoSection>
        <LogoWrapper>
          <Logo />
        </LogoWrapper>
      </LogoSection>
      <LoginCard>
        <Title>
          Welcome to Menu <br /> Operations & <br /> Assembly
        </Title>
        <Button label='Sign in with Yum' isSmall={true} onClick={handleLoginClick} />
      </LoginCard>
    </StyledContainer>
  );
};

export default Login;
